import { updateReviewAutomationSettings } from 'src/common/Scraper';
import {
  ReviewAutomationSettingsPayload,
  ReviewAutomationSettingsResponse
} from '../../types/review-automation.type';

/**
 * Saves/updates review automation settings via API.
 *
 * @param payload - The settings configuration payload to update.
 * @returns Promise resolving to the API response.
 */
export const saveReviewAutomationSettings = (
  payload: ReviewAutomationSettingsPayload
): Promise<ReviewAutomationSettingsResponse> => {
  return updateReviewAutomationSettings(payload);
};

export default saveReviewAutomationSettings;
